export default [
  {
    title: 'ข้อมูล ธุรกรรม',
    route: { name: 'UserTransactionData' },
    icon: 'TrendingUpIcon',
    action: 'all',
    resource: 'admin',
  },
]
